import React from 'react';
import { linkarEmailsHtml } from './linkarEmailsHtml';

interface HtmlViewProps {
  data?: { html?: string; [k: string]: unknown };
  [k: string]: unknown;
}

/**
 * Bloco `html` (conteúdo migrado ainda não convertido): a `view` recebe uma
 * cópia do HTML com os e-mails em texto envoltos em `<a href="mailto:">`
 * (AB#11165). O bloco salvo não muda; só a leitura.
 */
export const withEmailsClicaveisHtml = <P extends HtmlViewProps>(
  View: React.ComponentType<P>,
): React.FC<P> => {
  const EmailsClicaveisHtml: React.FC<P> = (props) => {
    const html = props?.data?.html;
    if (typeof html !== 'string') return <View {...props} />;
    const novo = linkarEmailsHtml(html);
    if (novo === html) return <View {...props} />;
    return <View {...props} data={{ ...props.data, html: novo }} />;
  };
  EmailsClicaveisHtml.displayName = `withEmailsClicaveisHtml(${
    View?.displayName || View?.name || 'Block'
  })`;
  return EmailsClicaveisHtml;
};

export default withEmailsClicaveisHtml;
